
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/DiscussionTopics/_publishedButton";
import "i18n!discussion_topics.edit_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'DiscussionTopics/EditView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <h1 class=\"screenreader-only\" style=\"display: inline\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <h1 class=\"screenreader-only\" style=\"display: inline\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAnnouncement), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </h1>\n";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "new_announcement_23af4598", "New Announcement", options) : helperMissing.call(depth0, "t", "new_announcement_23af4598", "New Announcement", options)))
    + "\n  ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "new_discussion_dae4fae3", "New Discussion", options) : helperMissing.call(depth0, "t", "new_discussion_dae4fae3", "New Discussion", options)))
    + "\n  ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <div id=\"discussion-edit-header\" class=\"discussion-edit-header row-fluid\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONDITIONAL_RELEASE_SERVICE_ENABLED), {hash:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <ul id=\"discussion-edit-header-tabs\">\n       <li><a href=\"#discussion-details-tab\" id=\"details_link\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "details_98a31b68", "Details", options) : helperMissing.call(depth0, "t", "details_98a31b68", "Details", options)))
    + "</a></li>\n       <li><a href=\"#mastery-paths-editor\" id=\"conditional_release_link\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a></li>\n       <span id=\"discussion-edit-header-spacer\"></span>\n       ";
  stack1 = self.invokePartial(partials['DiscussionTopics/publishedButton'], 'DiscussionTopics/publishedButton', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </ul>\n    ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <div class=\"span4 offset8 text-right\">\n        ";
  stack1 = self.invokePartial(partials['DiscussionTopics/publishedButton'], 'DiscussionTopics/publishedButton', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <h1 id=\"discussion-title\" class=\"title\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n        <input type=\"hidden\" name=\"title\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n      ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <label class=\"hidden-inline-text\" for=\"discussion-title\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "topic_title", "Topic Title", options) : helperMissing.call(depth0, "t", "topic_title", "Topic Title", options)))
    + "\n        </label>\n        <input type=\"text\"\n               id=\"discussion-title\"\n               name=\"title\"\n               placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "topic_title", "Topic Title", options) : helperMissing.call(depth0, "t", "topic_title", "Topic Title", options)))
    + "\"\n               value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n               maxlength=\"254\"\n               class=\"input-block-level\">\n      ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div id=\"discussion-description\" class=\"discussion-description\">\n          "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.message), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.message), options)))
    + "\n        </div>\n      ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.use_rce_enhancements), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <div style=\"clear:both;\"></div>\n        <textarea name=\"message\"\n                  class=\"input-block-level\"\n                  style=\"width: 100%; min-height: 200px;\">\n          "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{
    'forEditing': (1)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.message), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.message), options)))
    + "\n        </textarea>\n      ";
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div style=\"float: right;\">\n            <a href=\"#\" class=\"rte_switch_views_link\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_html", "HTML Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_html", "HTML Editor", options)))
    + "\n            </a>\n            <a href=\"#\" class=\"rte_switch_views_link\" style=\"display:none;\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "#editor.switch_editor_rich_text", "Rich Content Editor", options) : helperMissing.call(depth0, "t", "#editor.switch_editor_rich_text", "Rich Content Editor", options)))
    + "\n            </a>\n          </div>\n        ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div class=\"control-group\" style=\"margin-left: -75px\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(25, program25, data),fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <div class=\"controls\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.programWithDepth(27, program27, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.FEATURES)),stack1 == null || stack1 === false ? stack1 : stack1.usage_rights_discussion_topics), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <label class=\"control-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "attachment", "Attachment", options) : helperMissing.call(depth0, "t", "attachment", "Attachment", options)))
    + "</label>\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <label class=\"control-label\"\n          aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_attachment_93868828", "Add Attachment", options) : helperMissing.call(depth0, "t", "add_attachment_93868828", "Add Attachment", options)))
    + "\"\n          for=\"discussion_attachment_uploaded_data\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "attachment", "Attachment", options) : helperMissing.call(depth0, "t", "attachment", "Attachment", options)))
    + "\n        </label>\n      ";
  return buffer;
  }

function program27(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <div class=\"attachmentRow\">\n            <a aria-label=\"attachment\" href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\""
    + escapeExpression((helper = helpers.mimeClass || (depth0 && depth0.mimeClass),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0['content-type']), options) : helperMissing.call(depth0, "mimeClass", (depth0 && depth0['content-type']), options)))
    + "\">\n              ";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            </a>\n            ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth1 && depth1.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </div>\n        ";
  return buffer;
  }
function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              <button type=\"button\"\n                      class=\"close btn btn-link removeAttachment\"\n                      style=\"float:none\"\n                      aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "remove_attachment_ceae0973", "Remove Attachment", options) : helperMissing.call(depth0, "t", "remove_attachment_ceae0973", "Remove Attachment", options)))
    + "\">×</button>\n            ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <input type=\"file\"\n                 name=\"attachment\"\n                 ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                 id=\"discussion_attachment_uploaded_data\" >\n        ";
  return buffer;
  }
function program31(depth0,data) {
  
  
  return "style=\"display:none\"";
  }

function program33(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.USAGE_RIGHTS_REQUIRED), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_files), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program35(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div class=\"control-group\" style=\"margin-left: -75px\">\n          <label class=\"control-label\"\n            for=\"usage_rights_control\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "set_usage_rights_a4e47ed9", "Set usage rights", options) : helperMissing.call(depth0, "t", "set_usage_rights_a4e47ed9", "Set usage rights", options)))
    + "\n          </label>\n          <div class=\"controls\">\n            <div id=\"usage_rights_control\" />\n            <div id=\"usage_rights_modal\" />\n          </div>\n        </div>\n        ";
  return buffer;
  }

function program37(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <legend class=\"control-label\" style=\"text-align:start; margin-bottom: 0\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "options", "Options", options) : helperMissing.call(depth0, "t", "options", "Options", options)))
    + "</legend>\n    <div class=\"control-group\">\n      <div class=\"controls\" style=\"text-align:start; margin-left:0\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isTopic), {hash:{},inverse:self.noop,fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contextIsCourse), {hash:{},inverse:self.noop,fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canModerate), {hash:{},inverse:self.noop,fn:self.program(49, program49, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAssignment), {hash:{},inverse:self.noop,fn:self.program(52, program52, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n        <div><label class=\"checkbox short-label\" for=\"allow_rating\">\n          "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("allow_rating"),
    'class': ("element_toggler"),
    'checked': ((depth0 && depth0.allow_rating)),
    'aria-controls': ("rating_settings_container")
  },data:data},helper ? helper.call(depth0, "allow_rating", options) : helperMissing.call(depth0, "checkbox", "allow_rating", options)))
    + "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "allow_liking", "Allow liking", options) : helperMissing.call(depth0, "t", "allow_liking", "Allow liking", options)))
    + "\n        </label></div>\n        <div id=\"rating_settings_container\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.allow_rating), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.allow_rating), options)))
    + "; margin-left: 20px;\">\n          <div><label class=\"checkbox short-label\" for=\"only_graders_can_rate\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("only_graders_can_rate"),
    'class': ("element_toggler"),
    'checked': ((depth0 && depth0.only_graders_can_rate))
  },data:data},helper ? helper.call(depth0, "only_graders_can_rate", options) : helperMissing.call(depth0, "checkbox", "only_graders_can_rate", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "only_graders_can_like", "Only graders can like", options) : helperMissing.call(depth0, "t", "only_graders_can_like", "Only graders can like", options)))
    + "\n          </label></div>\n          <div><label class=\"checkbox short-label\" for=\"sort_by_rating\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("sort_by_rating"),
    'class': ("element_toggler"),
    'checked': ((depth0 && depth0.sort_by_rating))
  },data:data},helper ? helper.call(depth0, "sort_by_rating", options) : helperMissing.call(depth0, "checkbox", "sort_by_rating", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "sort_by_likes", "Sort by likes", options) : helperMissing.call(depth0, "t", "sort_by_likes", "Sort by likes", options)))
    + "\n          </label></div>\n        </div>\n\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.STUDENT_PLANNER_ENABLED), {hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    ";
  return buffer;
  }
function program38(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div><label class=\"checkbox short-label\" for=\"threaded\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "threaded", options) : helperMissing.call(depth0, "checkbox", "threaded", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "allow_threaded_replies", "Allow threaded replies", options) : helperMissing.call(depth0, "t", "allow_threaded_replies", "Allow threaded replies", options)))
    + "\n          </label></div>\n        ";
  return buffer;
  }

function program40(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAnnouncement), {hash:{},inverse:self.program(47, program47, data),fn:self.program(41, program41, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program41(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <div><label class=\"checkbox short-label\" for=\"delay_posting\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'checked': ((depth0 && depth0.delayed_post_at)),
    'class': ("element_toggler"),
    'aria-controls': ("discussion_topic_delay_post_container")
  },data:data},helper ? helper.call(depth0, "delay_posting", options) : helperMissing.call(depth0, "checkbox", "delay_posting", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "delay_posting", "Delay posting", options) : helperMissing.call(depth0, "t", "delay_posting", "Delay posting", options)))
    + "\n            </label></div>\n            <label class=\"screenreader-only\" id=\"discussion_topic_delay_post_accessible_label\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delay_posting_this_topic_until_aa483eec", "Delay posting this topic until", options) : helperMissing.call(depth0, "t", "delay_posting_this_topic_until_aa483eec", "Delay posting this topic until", options)))
    + "\n              ";
  if (helper = helpers.datepickerScreenreaderPrompt) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.datepickerScreenreaderPrompt); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            </label>\n            <div><label id=\"discussion_topic_delay_post_container\"\n                   style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.delayed_post_at), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.delayed_post_at), options)))
    + "\"\n                   class=\"checkbox short-label\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "post_at", "Post At", options) : helperMissing.call(depth0, "t", "post_at", "Post At", options)))
    + "\n              <input type=\"text\"\n                     class=\"datetime_field input-medium\"\n                     name=\"delayed_post_at\"\n                     \n                     value=\""
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.delayed_post_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.delayed_post_at), options)))
    + "\"\n                     aria-labelledby=\"discussion_topic_delay_post_accessible_label\"\n                     data-tooltip='{\"position\":\"top\",\"force_position\":\"true\"}'\n                     title=\"";
  if (helper = helpers.accessibleDateFormat) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.accessibleDateFormat); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n            </label></div>\n            ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.announcementsLocked), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }
function program42(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <div><label class=\"checkbox short-label\" for=\"allow_user_comments\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.title), {hash:{},inverse:self.program(45, program45, data),fn:self.program(43, program43, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "allow_users_to_comment_45b8f753", "Allow users to comment", options) : helperMissing.call(depth0, "t", "allow_users_to_comment_45b8f753", "Allow users to comment", options)))
    + "\n            </label></div>\n            <div><label class=\"checkbox short-label\" for=\"require_initial_post\" style=\"margin-left: 2em;\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "require_initial_post", options) : helperMissing.call(depth0, "checkbox", "require_initial_post", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "users_must_post_before_seeing_replies", "Users must post before seeing replies", options) : helperMissing.call(depth0, "t", "users_must_post_before_seeing_replies", "Users must post before seeing replies", options)))
    + "\n            </label></div>\n            ";
  return buffer;
  }
function program43(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'checked': ((depth0 && depth0.unlocked))
  },data:data},helper ? helper.call(depth0, "allow_user_comments", options) : helperMissing.call(depth0, "checkbox", "allow_user_comments", options)))
    + "\n              ";
  return buffer;
  }

function program45(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'checked': (((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CREATE_ANNOUNCEMENTS_UNLOCKED))
  },data:data},helper ? helper.call(depth0, "allow_user_comments", options) : helperMissing.call(depth0, "checkbox", "allow_user_comments", options)))
    + "\n              ";
  return buffer;
  }

function program47(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div><label class=\"checkbox short-label\" for=\"require_initial_post\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "require_initial_post", options) : helperMissing.call(depth0, "checkbox", "require_initial_post", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "users_must_post_before_seeing_replies", "Users must post before seeing replies", options) : helperMissing.call(depth0, "t", "users_must_post_before_seeing_replies", "Users must post before seeing replies", options)))
    + "\n          </label></div>\n          ";
  return buffer;
  }

function program49(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <div><label class=\"checkbox short-label\" for=\"podcast_enabled\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'checked': ((depth0 && depth0.podcast_url)),
    'class': ("element_toggler"),
    'aria-controls': ("podcast_has_student_posts_container")
  },data:data},helper ? helper.call(depth0, "podcast_enabled", options) : helperMissing.call(depth0, "checkbox", "podcast_enabled", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "enable_podcast_feed", "Enable podcast feed", options) : helperMissing.call(depth0, "t", "enable_podcast_feed", "Enable podcast feed", options)))
    + "\n          </label></div>\n\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contextIsCourse), {hash:{},inverse:self.noop,fn:self.program(50, program50, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program50(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <div><label id=\"podcast_has_student_posts_container\"\n                   style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.podcast_url), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.podcast_url), options)))
    + "\"\n                   class=\"checkbox short-label\" for=\"podcast_has_student_posts\">\n              "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "podcast_has_student_posts", options) : helperMissing.call(depth0, "checkbox", "podcast_has_student_posts", options)))
    + "\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "include_replies_in_podcast_feed", "Include student replies in podcast feed", options) : helperMissing.call(depth0, "t", "include_replies_in_podcast_feed", "Include student replies in podcast feed", options)))
    + "\n            </label></div>\n          ";
  return buffer;
  }

function program52(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div><label class=\"checkbox short-label\" for=\"use_for_grading\">\n            "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("use_for_grading"),
    'class': ("element_toggler"),
    'aria-controls': ("assignment_options"),
    'checked': ((depth0 && depth0.set_assignment))
  },data:data},helper ? helper.call(depth0, "assignment.set_assignment", options) : helperMissing.call(depth0, "checkbox", "assignment.set_assignment", options)))
    + "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "use_for_grading", "Graded", options) : helperMissing.call(depth0, "t", "use_for_grading", "Graded", options)))
    + "\n          </label></div>\n        ";
  return buffer;
  }

function program54(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isTopic), {hash:{},inverse:self.noop,fn:self.program(55, program55, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program55(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <div id=\"todo_options\" style=\""
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.set_assignment), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.set_assignment), options)))
    + "\">\n              <div><label class=\"checkbox short-label\" for=\"allow_todo_date\">\n                "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("allow_todo_date"),
    'class': ("element_toggler"),
    'aria-controls': ("todo_date_input")
  },data:data},helper ? helper.call(depth0, "allow_todo_date", options) : helperMissing.call(depth0, "checkbox", "allow_todo_date", options)))
    + "\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_to_student_to_do_58e66b4b", "Add to student to-do", options) : helperMissing.call(depth0, "t", "add_to_student_to_do_58e66b4b", "Add to student to-do", options)))
    + "\n              </label></div>\n              <div id=\"todo_date_input\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.allow_todo_date), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.allow_todo_date), options)))
    + "; margin-left: 20px;\" />\n            </div>\n          ";
  return buffer;
  }

function program57(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isLargeRoster), {hash:{},inverse:self.noop,fn:self.program(58, program58, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contextIsCourse), {hash:{},inverse:self.noop,fn:self.program(61, program61, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program58(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contextIsCourse), {hash:{},inverse:self.noop,fn:self.program(59, program59, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program59(depth0,data) {
  
  
  return "\n        <div id=\"group_category_options\" class=\"control-group\" style=\"width: 295px\"></div>\n      ";
  }

function program61(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div id=\"availability_options\" style=\""
    + escapeExpression((helper = helpers.hiddenIf || (depth0 && depth0.hiddenIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.set_assignment), options) : helperMissing.call(depth0, "hiddenIf", (depth0 && depth0.set_assignment), options)))
    + "\">\n        <fieldset>\n          <div class=\"control-group\" style=\"margin-left: -66px\">\n            <label class=\"control-label\" for=\"delayed_post_at\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "available_from", "Available From", options) : helperMissing.call(depth0, "t", "available_from", "Available From", options)))
    + "\n            </label>\n            <label class=\"screenreader-only\" id=\"discussion_topic_available_from_accessible_label\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "discussion_topic_will_be_available_starting_at_46aa7477", "Discussion Topic will be available starting at", options) : helperMissing.call(depth0, "t", "discussion_topic_will_be_available_starting_at_46aa7477", "Discussion Topic will be available starting at", options)))
    + "\n              ";
  if (helper = helpers.datepickerScreenreaderPrompt) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.datepickerScreenreaderPrompt); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            </label>\n            <div class=\"controls\">\n              <input type=\"text\"\n                     class=\"datetime_field input-medium\"\n                     style=\"width: 122px\"\n                     name=\"delayed_post_at\"\n                     id=\"delayed_post_at\"\n                     aria-labelledby=\"discussion_topic_available_from_accessible_label\"\n                     \n                     value=\""
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.delayed_post_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.delayed_post_at), options)))
    + "\"\n                     data-tooltip='{\"position\":\"top\",\"force_position\":\"true\"}'\n                     ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), {hash:{},inverse:self.noop,fn:self.program(62, program62, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                     "
    + escapeExpression((helper = helpers.readonlyIf || (depth0 && depth0.readonlyIf),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), options) : helperMissing.call(depth0, "readonlyIf", ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), options)))
    + "\n              />\n            </div>\n          </div>\n        </fieldset>\n\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isTopic), {hash:{},inverse:self.noop,fn:self.program(64, program64, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    ";
  return buffer;
  }
function program62(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                      title=\"";
  if (helper = helpers.accessibleDateFormat) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.accessibleDateFormat); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                     ";
  return buffer;
  }

function program64(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <fieldset>\n            <div class=\"control-group\" style=\"margin-left: -66px\">\n              <label class=\"control-label\" for=\"lock_at\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "until", "Until", options) : helperMissing.call(depth0, "t", "until", "Until", options)))
    + "</label>\n              <label class=\"screenreader-only\" id=\"discussion_topic_available_until_accessible_label\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "discussion_topic_will_be_available_until_f5e3abc8", "Discussion Topic will be available until", options) : helperMissing.call(depth0, "t", "discussion_topic_will_be_available_until_f5e3abc8", "Discussion Topic will be available until", options)))
    + "\n                ";
  if (helper = helpers.datepickerScreenreaderPrompt) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.datepickerScreenreaderPrompt); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n              </label>\n              <div class=\"controls\">\n                <input type=\"text\"\n                       class=\"datetime_field input-medium\"\n                       style=\"width: 122px\"\n                       name=\"lock_at\"\n                       id=\"lock_at\"\n                       aria-labelledby=\"discussion_topic_available_until_accessible_label\"\n                       \n                       value=\""
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.lock_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.lock_at), options)))
    + "\"\n                       data-tooltip='{\"position\":\"top\",\"force_position\":\"true\"}'\n                       ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), {hash:{},inverse:self.noop,fn:self.program(65, program65, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                       "
    + escapeExpression((helper = helpers.readonlyIf || (depth0 && depth0.readonlyIf),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), options) : helperMissing.call(depth0, "readonlyIf", ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.availability_dates), options)))
    + "\n                />\n              </div>\n            </div>\n          </fieldset>\n        ";
  return buffer;
  }
function program65(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                        title=\"";
  if (helper = helpers.accessibleDateFormat) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.accessibleDateFormat); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"}}\n                       ";
  return buffer;
  }

function program67(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div id=\"assignment_options\" style=\""
    + escapeExpression((helper = helpers.hiddenUnless || (depth0 && depth0.hiddenUnless),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.set_assignment), options) : helperMissing.call(depth0, "hiddenUnless", (depth0 && depth0.set_assignment), options)))
    + "\">\n      <fieldset>\n        <div class=\"control-group\">\n          <label class=\"control-label\" for=\"discussion_topic_assignment_points_possible\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "points_possible", "Points Possible", options) : helperMissing.call(depth0, "t", "points_possible", "Points Possible", options)))
    + "\n          </label>\n          <div class=\"controls\">\n            <input type=\"text\"\n                   id=\"discussion_topic_assignment_points_possible\"\n                   name=\"assignment[points_possible]\"\n                   class=\"input-small\"\n                   value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.pointsPossible), options) : helperMissing.call(depth0, "n", ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.pointsPossible), options)))
    + "\"\n                   "
    + escapeExpression((helper = helpers.readonlyIf || (depth0 && depth0.readonlyIf),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.points), options) : helperMissing.call(depth0, "readonlyIf", ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.points), options)))
    + " />\n          </div>\n            <div id=discussion_point_change_warning class=\"alert form-column-right\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "if_you_change_an_assignment_s_points_possible_you__25a0edad", "If you change an assignment's points possible you must regrade the assignment.", options) : helperMissing.call(depth0, "t", "if_you_change_an_assignment_s_points_possible_you__25a0edad", "If you change an assignment's points possible you must regrade the assignment.", options)))
    + "\n            </div>\n        </div>\n\n        <div id=\"grading_type_options\" class=\"control-group\"></div>\n\n        <div id=\"post_to_sis_options\" class=\"control-group\"></div>\n\n        <div id=\"assignment_group_options\" class=\"control-group\"></div>\n\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isLargeRoster), {hash:{},inverse:self.noop,fn:self.program(68, program68, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </fieldset>\n\n      <div id=\"overrides-wrapper\">\n        <div class=\"form-column-left\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "assign_eedf72bb", "Assign", options) : helperMissing.call(depth0, "t", "assign_eedf72bb", "Assign", options)))
    + "\n        </div>\n        <div class=\"overrides-column-right js-assignment-overrides overrideFormFlex\">\n        </div>\n      </div>\n\n    </div>\n  ";
  return buffer;
  }
function program68(depth0,data) {
  
  
  return "\n          <div id=\"peer_review_options\" class=\"control-group\"></div>\n        ";
  }

function program70(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isAnnouncement), {hash:{},inverse:self.noop,fn:self.program(71, program71, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program71(depth0,data) {
  
  
  return "\n    <div id=\"mastery-paths-editor\">\n      <div id=\"conditional-release-target\" />\n    </div>\n  ";
  }

function program73(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <button type=\"button\"\n            data-text-while-loading=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "saving", "Saving...", options) : helperMissing.call(depth0, "t", "saving", "Saving...", options)))
    + "\"\n            class=\"btn btn-default save_and_publish\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "buttons.save_and_publish", "Save & Publish", options) : helperMissing.call(depth0, "t", "buttons.save_and_publish", "Save & Publish", options)))
    + "\n    </button>\n  ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.title), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div id=\"discussion-edit-view\" class=\"ui-tabs-minimal\">\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isAnnouncement), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div id=\"discussion-details-tab\">\n  <fieldset style=\"min-width: 0;\">\n    <div class=\"control-group\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"control-group\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.lockedItems)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},inverse:self.program(19, program19, data),fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n\n  </fieldset>\n  <fieldset>\n    <div id=\"sections_autocomplete_root\" style=\"margin-right: 80px\"></div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAttach), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </fieldset>\n\n  <fieldset style=\"display:flex; flex-direction:column\">\n\n    ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(37, program37, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.isTopic), (depth0 && depth0.contextIsCourse), (depth0 && depth0.canModerate), (depth0 && depth0.showAssignment), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.isTopic), (depth0 && depth0.contextIsCourse), (depth0 && depth0.canModerate), (depth0 && depth0.showAssignment), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  </fieldset>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isTopic), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAssignment), {hash:{},inverse:self.noop,fn:self.program(67, program67, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CONDITIONAL_RELEASE_SERVICE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(70, program70, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div id=\"assignment_external_tools\"></div>\n\n<div id=\"edit_discussion_form_buttons\" class=\"form-actions flush\" style=\"padding-left: 0px; margin-right: -0.75em\">\n  <button type=\"button\" class=\"btn cancel_button\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "\n  </button>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canPublish), {hash:{},inverse:self.noop,fn:self.program(73, program73, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <button type=\"submit\"\n          data-text-while-loading=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "saving", "Saving...", options) : helperMissing.call(depth0, "t", "saving", "Saving...", options)))
    + "\"\n          class=\"btn btn-primary\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("discussion_topics.edit_view")
  },data:data},helper ? helper.call(depth0, "save", "Save", options) : helperMissing.call(depth0, "t", "save", "Save", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  